import React, { FC } from 'react';

export const TabAction: FC<{ children?: React.ReactNode }> = ({ children }) => {
	return <div className="TabGroup__action">{children}</div>;
};
